import React from 'react';
import styled from 'styled-components';
import { fetchUser } from '../firestore';

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Logo = styled.img.attrs({
  src: require('./images/logo.png'),
})`
  margin: 20px 0 30px 0;
  height: 64px;
  display: flex;
`;

const AppStore = ({ href }: { href: string }) => (
  <a href={href}>
    <AppStore.Logo />
  </a>
);

AppStore.Logo = styled.img.attrs({
  src: require('./images/appstore.svg'),
})`
  width: 145px;
  margin-top: 40px;
  @media (min-width: 920px) {
    width: 180px;
  }
`;

const Description = styled.div`
  text-align: center;
  line-height: 25px;
  font-size: 16px;
  margin: 30px 15px;
  max-width: 360px;
  @media (min-width: 920px) {
    font-size: 30px;
    line-height: 45px;
    max-width: 680px;
  }
`;

const Content = styled.div`
  display: flex;
`;

const Box = styled.div`
  display: flex;
  background-color: white;
  margin: 50px 20px 50px;
  border-radius: 10px;
  padding: 70px 0 40px 0;
  align-self: stretch;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  @media (min-width: 920px) {
    margin: 70px 50px 50px 50px;
    padding: 90px 15px 40px 15px;
  }
`;

const Name = styled.div`
  color: #4d67f0;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  @media (min-width: 920px) {
    font-size: 25px;
    line-height: 35px;
  }
`;

const AvatarImg = styled.img`
  width: 98px;
  height: 98px;
  border-radius: 49px;
  margin-top: 4px;
  background-color: #eeeeee;
  @media (min-width: 920px) {
    width: 140px;
    height: 140px;
    border-radius: 70px;
  }
`;

const AvatarPlaceholder = styled.div`
  width: 98px;
  height: 98px;
  border-radius: 49px;
  margin: 4px 0 0 4px;
  background-color: #eeeeee;
  @media (min-width: 920px) {
    width: 140px;
    height: 140px;
    border-radius: 70px;
  }
`;

const AvatarContainer = styled.div`
  width: 106px;
  height: 106px;
  border-radius: 53px;
  background-color: #ffffff;
  position: absolute;
  top: 120px;
  @media (min-width: 920px) {
    width: 146px;
    height: 146px;
    border-radius: 73px;
  }
`;

const Avatar = (src: string, isError: boolean) => {
  if (isError) {
    return;
  }

  if (src) {
    return (
      <AvatarContainer>
        <AvatarImg src={src} />
      </AvatarContainer>
    );
  } else {
    return (
      <AvatarContainer>
        <AvatarPlaceholder />
      </AvatarContainer>
    );
  }
};

const ListingsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  flex-wrap: wrap;
  @media (min-width: 500px) {
    margin: 0 20px;
  }
`;

const ListingContainer = styled.div`
  width: 106px;
  height: 106px;
  border-radius: 5px;
  background-color: #4d67f0;
  margin: 10px;
  @media (min-width: 920px) {
    width: 166px;
    height: 166px;
  }
`;

const Listing = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 3px;
  margin: 3px 0 0 0;
  background-color: #eeeeee;
  @media (min-width: 920px) {
    width: 160px;
    height: 160px;
  }
`;

const Listings = (listings: string[]) => {
  if (listings) {
    const items = listings.map((listing, index) => (
      <ListingContainer key={index}>
        <Listing src={listing} />
      </ListingContainer>
    ));

    return <ListingsContainer>{items}</ListingsContainer>;
  }
};

interface UsersPageState {
  isLoading: boolean;
  isError: boolean;
  avatar: string;
  userName: string;
  storeFrontName: string;
  listings: string[];
}

class UsersPage extends React.Component<{}, UsersPageState> {
  constructor(props: any) {
    super(props);

    this.state = {
      isLoading: true,
      isError: false,
      avatar: '',
      userName: '',
      storeFrontName: '',
      listings: [],
    };
  }

  public componentDidMount() {
    document.body.className = 'yellow-background';
  }

  public async componentWillMount() {
    const id = window.location.pathname && window.location.pathname.slice(7);
    if (id) {
      this.setState({ isLoading: true });
      const result = await fetchUser(id);
      if (result) {
        this.setState(result);
        return this.setState({ isLoading: false });
      }
    }

    this.setState({ isLoading: false, isError: true });
  }

  public render() {
    const {
      avatar,
      userName,
      storeFrontName,
      listings,
      isError,
      isLoading,
    } = this.state;
    return (
      <Container>
        <Logo />
        <Content>
          <Box>
            {Avatar(avatar, isLoading || isError)}
            <Name>{userName}</Name>
            <Name>{storeFrontName}</Name>
            <Description>
              Don't miss the coolest LIVE shopping experience. Download the app
              to enjoy the new generation of shopping
            </Description>
            {Listings(listings)}
            <AppStore href="https://itunes.apple.com/us/app/popshop-start-shopping-us/id1009480270?ls=1&mt=8" />
          </Box>
        </Content>
      </Container>
    );
  }
}

export default UsersPage;
